module.exports = function getResource(label, vars = []) {
    let resources = {
        subscribeLabel: 'Subscribe to Sephora emails',
        popoverContent: 'Sephora Beauty Canada, Inc. (600 de Maisonneuve Boulevard West, Suite 2400, Montréal Quebec, H3A 3J2, sephora.ca) is requesting consent on its own behalf and on behalf of Sephora USA, Inc. (525 Market Street, Floor 32, San Francisco, CA 94105, sephora.com). You may withdraw your consent at any time.'
    };
    return resources[label];
};
